import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';
import FormBase from '@/components/forms/new/FormBase';
import QuantityField from './formFields/QuantityField';
import UnitPriceField from './formFields/UnitPriceField';
import DescriptionField from './formFields/DescriptionField';
import ItemCodeField from './formFields/ItemCodeField';
import { Button } from 'components/v4';
import DeleteConfirmationModal from 'pages/billing/plans/edit/DeleteConfirmationModal';

const InvoiceLineEdit = ({
    mode,
    state = {},
    onSubmit,
    onClose,
    darkMode,
    onBack,
    onDelete,
    isLoading,
    isDeleting,
}) => {
    const { isOpen, onOpen, onClose: onModalClose } = useDisclosure();

    const initialValues = {
        quantity: state.quantity ?? '',
        unitPrice: state.unitPrice ?? '',
        description: state.description || '',
        itemCode: state.itemCode || '',
    };

    // Validation schema if needed
    const validate = (values) => {
        const errors = {};
        if (!values.quantity) {
            errors.quantity = 'Required';
        }
        if (!values.itemCode) {
            errors.itemCode = 'Required';
        }
        return errors;
    };

    return (
        <>
            {Object.keys(state).length > 0 && (
                <Box
                    bg={darkMode ? '#2C5282' : '#BEE3F8'}
                    p={4}
                    borderRadius={8}
                    maxWidth={895}
                    mb={4}>
                    <Flex align="center">
                        <InfoIcon
                            color={darkMode ? '#90CDF4' : '#2C5282'}
                            mr={3}
                        />
                        <Box
                            fontWeight="medium"
                            color={darkMode ? '#90CDF4' : '#2C5282'}>
                            Editing existing invoice line
                        </Box>
                    </Flex>
                </Box>
            )}
            <FormBase
                //header={mode === 'edit' ? 'Edit Invoice Line' : 'Add Invoice Line'}
                subTitleHeader={false}
                initialValues={initialValues}
                validate={validate}
                onClose={onClose}
                finalFormSubmit={onSubmit}
                darkMode={darkMode}
                customClick={true}
                onBack={onBack}
                isLoading={isLoading}
                extraButton={
                    mode === 'edit' && (
                        <Flex justify="flex-end" width="100%">
                            <Button
                                w={142}
                                colorScheme="red"
                                onClick={onOpen}
                                isDisabled={isDeleting || isLoading}>
                                Delete
                            </Button>
                        </Flex>
                    )
                }>
                {({ errors, touched }) => {
                    const fields = [
                        <QuantityField
                            key="quantity"
                            darkMode={darkMode}
                            errors={errors}
                            touched={touched}
                            mode={mode}
                        />,
                        <UnitPriceField
                            key="unitPrice"
                            darkMode={darkMode}
                            errors={errors}
                            touched={touched}
                            mode={mode}
                        />,
                        <DescriptionField
                            key="description"
                            darkMode={darkMode}
                            errors={errors}
                            touched={touched}
                            mode={mode}
                        />,
                        <ItemCodeField
                            key="itemCode"
                            darkMode={darkMode}
                            errors={errors}
                            touched={touched}
                            mode={mode}
                        />,
                    ];

                    return fields;
                }}
            </FormBase>
            <DeleteConfirmationModal
                isOpen={isOpen}
                onClose={onModalClose}
                itemName={state?.description}
                onConfirm={() => {
                    onDelete();
                    onModalClose();
                }}
                isDeleting={isDeleting}
                itemType="Invoice Line"
            />
        </>
    );
};

export default InvoiceLineEdit;
